/*
 * NOTE: all the values in this modal that are related to lists are pulled from this file.
 *       in order to make sure that the modal could be reworked individually in the future this
 *       was necessary. Changes in here should not affect other modals.
 */

export const CAP_VOLS = "capVolsCurve";
export const MARKET_EXPECTATIONS_SHOCK = "MARKET_EXPECTATIONS";
export const PARALLEL_SHOCK = "PARALLEL";
export const STANDARD_DEVIATION_SHOCK = "STANDARD_DEVIATION";

export const INTEREST_RATE_TYPES = {
  FIXED_RATE: "FIXED",
  FLOATING_RATE: "FLOATING"
};
export const INTEREST_RATE_TYPE_IDS = {
  FIXED_RATE: "53669856-4681-11e9-82f6-0242ac120002",
  FLOATING_RATE: "5813c493-4681-11e9-82f6-0242ac120002"
};
export const LOAN_TYPE_LIST = [
  { label: "Balance Sheet", name: "Balance Sheet", value: 4, isAssumptionType: true },
  { label: "Bridge", name: "Bridge", value: 5, isAssumptionType: true },
  { label: "CMBS", name: "CMBS", value: 3, isAssumptionType: true },
  { label: "Construction", name: "Construction", value: 1, isAssumptionType: true },
  { label: "Freddie Mac", name: "Freddie Mac", value: 7, isAssumptionType: true },
  { label: "Fannie Mae", name: "Fannie Mae", value: 6, isAssumptionType: true },
  { label: "HUD", name: "HUD", value: 8, isAssumptionType: true },
  { label: "Life Co", name: "Life Co", value: 11, isAssumptionType: true },
  { label: "Line of Credit", name: "Line of Credit", value: 13, isAssumptionType: false },
  { label: "Value Add", name: "Value Add", value: 10, isAssumptionType: true },
  { label: "Other", name: "Other", value: 2, isAssumptionType: false },
  { label: "Mezz", name: "Mezz", value: 12, isAssumptionType: false },
  { label: "Pref. Equity", name: "Pref. Equity", value: 9, isAssumptionType: false },
  { label: "Agency", name: "Agency", value: 14, isAssumptionType: true }
];

export const SHOCKS = [
  { name: "Market Expectations", label: "Market Expectations", value: MARKET_EXPECTATIONS_SHOCK },
  { name: "Parallel Shift", label: "Parallel Shift", value: PARALLEL_SHOCK },
  { name: "Standard Deviation", label: "Standard Deviation", value: STANDARD_DEVIATION_SHOCK }
];
